import { render, staticRenderFns } from "./lineview.vue?vue&type=template&id=2b046330&scoped=true"
import script from "./lineview.vue?vue&type=script&lang=js"
export * from "./lineview.vue?vue&type=script&lang=js"
import style0 from "./lineview.vue?vue&type=style&index=0&id=2b046330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b046330",
  null
  
)

export default component.exports